import productBanner from "../img/products.png";
import IconBadge from "../IconBadge";
import Partners from "../img/partners.png";
import solution from "../img/solutions.png";

import Partner1 from "../img/partner/oracle.jpg";
import partner2 from "../img/partner/microsoft.png";
import Partner3 from "../img/Brands/servicenow.png";
import Partner4 from "../img/partner/zoho-partner.png";
import Partner5 from "../img/partner/tally.png";
import IconImage from "../IconImage";

import Solution1 from "../img/Solutions/crm-bg-white.jpg";
import Solution2 from "../img/Solutions/ai.jpg";
import Solution3 from "../img/Solutions/erp-bg-white.jpg";
import Solution4 from "../img/Solutions/di.jpg";
import Solution5 from "../img/Solutions/cs-bg-white.jpg";

export const menus = [
  {
    key: "Solutions",
    label: "Solutions",
    path: "/solutions",
    src: solution,
    subMenu: [
      {
        text: "Sales/Service CRM",
        path: "/",

        description: {
          title: "Sales / Service CRM",
          sections: [
            {
              heading: "Sales CRM",
              items: ["Zoho CRM (Partner)", "Salesforce (Partner)", "HubSpot"],
            },
            {
              heading: "Service CRM",
              items: ["ServiceNow (Partner)", "Zendesk"],
            },
          ],
        },

        icon: <IconImage src={Solution1} alt="CRM" />,

        color: "#4A90E2",
      },
      {
        text: "Artificial Intelligence",
        path: "/",

        description: {
          title: "Artificial Intelligence Solutions",
          sections: [
            {
              heading: "LLMs",
              items: ["OpenAI", "Gemini", "Copilot", "Ollama"],
            },
          ],
        },
        icon: <IconImage src={Solution2} alt="AI" />,
        color: "#4A90E2",
      },

      {
        text: "Enterprise Resource Planning",
        path: "/",
        description: {
          title: "Enterprise Resource Planning",
          sections: [
            {
              heading: "Platforms",
              items: [
                "Oracle NetSuite (Partner)",
                "Oracle EBS",
                "Microsoft Dynamics 365",
                "SAP HANA",
                "Zoho One (Partner)",
                "Infor",
                "QuickBooks Online",
              ],
            },
          ],
        },

        icon: <IconImage src={Solution3} alt="ERP" />,

        color: "#4A90E2",
      },
      {
        text: "Data Integration",
        path: "/integration",
        description: {
          title: "Data Integration",
          sections: [
            {
              heading: "Capabilities",
              items: [
                "Integrates data across Cloud applications",
                "Supports on-prem applications",
                "Connects to databases",
                "Processes structured and unstructured data files",
              ],
            },
          ],
        },
        icon: <IconImage src={Solution4} alt="DI" />,

        color: "#4A90E2",
      },
      {
        text: "Cloud Solutions",
        path: "/",
        description: {
          title: "Cloud Platforms",
          sections: [
            {
              heading: "Platforms",
              items: [
                "Amazon Web Services (AWS)",
                "Microsoft Azure",
                "Google Cloud Platform (GCP)",
              ],
            },
            {
              heading: "Services",
              items: [
                "Cloud migration",
                "Application development",
                "Data engineering",
              ],
            },
          ],
        },
        icon: <IconImage src={Solution5} alt="CS" />,
        color: "#4A90E2",
      },
    ],
  },
  {
    key: "Products",
    label: "Products",
    path: "/products",
    src: productBanner,
    subMenu: [
      {
        text: "Centroid",
        path: "/",
        description: {
          title: "Centroid",
          sections: [
            {
              heading: "Overview",
              items: [
                "Centralized Dealer Management solution",
                "Supports PAN-India dealer network",
                "Designed for scalable dealer operations",
              ],
            },
          ],
        },
        icon: <IconBadge label="CEN" />,

        color: "#4A90E2",
      },

      {
        text: "Tiara Timesheet",
        path: "/",

        description: {
          title: "Tiara Timesheet",
          sections: [
            {
              heading: "Overview",
              items: [
                "AI-driven timesheet management application",
                "Tracks effort across projects and customers",
                "Supports internal initiatives and resource utilization",
              ],
            },
          ],
        },

        icon: <IconBadge label="TSH" />,
        color: "#4a90e2",
      },

      {
        text: "Tiara Integration",
        external: true,
        path: "https://tiaraintegration.com/",
        description: {
          title: "Tiara Integration",
          sections: [
            {
              heading: "Integrations",
              items: [
                // {
                //   label: "Charmhealth - QuickBooks Online",
                //   // path: "/charmhealth-quickbooks",
                // },
                "Charmhealth - QuickBooks Online",
                "ServiceNow - ERP Integration",
                "Zoho CRM - NetSuite",
                "Salesforce - NetSuite",
                "On-prem - AWS, Azure, GCP",
              ],
            },
          ],
        },
        icon: <IconBadge label="TIR" />,
        // color: "#4a90e2",
      },
    ],
  },
  {
    key: "Partners",
    label: "Partners",
    path: "/partner",
    src: Partners,
    subMenu: [
      {
        text: "ServiceNow Partner",
        path: "/servicenow-partner-washington-dc",
        description: {
          title: "ServiceNow Partner",
          sections: [
            {
              heading: "Consulting & Implementation",
              items: [
                "Authorized to perform end-to-end implementation of ServiceNow AI Platform",
              ],
            },
            {
              heading: "Build Partner",
              items: [
                "Develop SN Store applications that add platform value for ServiceNow customers",
              ],
            },
          ],
        },
        icon: <IconImage src={Partner3} alt="SNP" />,
        color: "#4a90e2",
      },

      {
        text: "Microsoft",
        path: "/",
        description: {
          title: "Microsoft Cloud Partner",
          sections: [
            {
              heading: "Capabilities",
              items: [
                "Migrate applications into Azure Cloud",
                "Build new apps on Azure",
                "Develop Power BI platforms",
              ],
            },
          ],
        },
        icon: <IconImage src={partner2} alt="MS" />,
        color: "#4a90e2",
      },

      {
        text: "Oracle",
        path: "/",
        description: {
          title: "Oracle NetSuite SDN Partner",
          sections: [
            {
              heading: "Services Offered",
              items: [
                "Oracle NetSuite customization",
                "Ongoing support and maintenance",
                "Add-on application development",
              ],
            },
          ],
        },

        icon: <IconImage src={Partner1} alt="ORA" />,
        color: "#4A90E2",
      },

      {
        text: "Zoho",
        path: "/zoho-products",
        description: {
          title: "Zoho Partner",
          sections: [
            {
              heading: "Services Offered",
              items: [
                "End-to-end implementation of Zoho One",
                "Zoho CRM setup and customization",
                "Zoho Books implementation",
                "Development of Zoho extensions",
              ],
            },
          ],
        },

        icon: <IconImage src={Partner4} alt="ZOHO" />,

        color: "#4A90E2",
      },
      {
        text: "Tally",
        path: "/",
        description: {
          title: "Tally Partner",
          sections: [
            {
              heading: "Experience & Services",
              items: [
                "Sales and solution partner for Tally",
                "GVLA (Government, Very Large Account) support",
                "Serving clients since 2010 (15+ years)",
              ],
            },
          ],
        },

        icon: <IconImage src={Partner5} alt="TALLY" />,
        color: "#4a90e2",
      },
    ],
  },
];
